import React from 'react';
import { ReactComponent as ArrowShadow } from '../../assets/icons/arrow-shadow.svg';
import { ReactComponent as CloseIcon } from '../../assets/icons/closeIcon.svg';

const Landmark = (props) => {
  const { index, landmark, panoramicWidth, orientation, currentFrame,
    toggleActiveStateOfLandmark } = props;
  const landmarkRef = React.useRef(null);
  const informationRef = React.useRef(null);
  const [isAnimatingIn, setIsAnimatingIn] = React.useState(false);
  const [isAnimatingOut, setIsAnimatingOut] = React.useState(false);
  const [arrowClass, setArrowClass] = React.useState("inactive");
  const MAX_DEGREES_DIFFERENCE_TO_SHOW_ARROWS = 30;
  const ICON_IMAGE_HEIGHT_PX = 120;
  const ICON_IMAGE_SELECTED_HEIGHT_PX = 180;
  const ICON_HEIGHT_DIFFERENCE_PX = (ICON_IMAGE_SELECTED_HEIGHT_PX - ICON_IMAGE_HEIGHT_PX) / 2;
  const INFORMATION_BOX_HEIGHT_ON_SELECTED_PX = 256;
  const INFORMATION_BOX_OVERLAPPED_ON_ICON_PX = 25;
  const LANDMARK_MARGIN_BOTTOM_VH = 3;

  React.useEffect( () => {
    if(landmarkRef.current){
      landmarkRef.current.style.top=`calc(100% 
        - ${ICON_IMAGE_SELECTED_HEIGHT_PX}px 
        - ${INFORMATION_BOX_HEIGHT_ON_SELECTED_PX}px 
        - ${LANDMARK_MARGIN_BOTTOM_VH}vh 
        + ${INFORMATION_BOX_OVERLAPPED_ON_ICON_PX}px
        + ${ICON_HEIGHT_DIFFERENCE_PX}px)`;
    }
  },[])

  React.useEffect( () => {
    placeLandmarkInBackground()
  },[panoramicWidth,landmark.degrees])

  React.useEffect( () => {
    if(landmark.active){
      checkIfArrowIndicatorsAreNeeded(orientation);
    }
  },[orientation,landmark.active])

  const checkIfArrowIndicatorsAreNeeded = (orientation) => {
    const degreesOff = degreesAwayOfLandmark(orientation)
    if( degreesOff > MAX_DEGREES_DIFFERENCE_TO_SHOW_ARROWS){
      setArrowClass("left");
    }else if( degreesOff < - MAX_DEGREES_DIFFERENCE_TO_SHOW_ARROWS){
      setArrowClass("right");
    }else{
      setArrowClass("inactive");
    }
  }

  const degreesAwayOfLandmark = (orientation) => {
    return ((currentFrame - 1) * 360 + orientation) - 
      (landmark.iteration * 360 + landmark.degrees);
  }

  const placeLandmarkInBackground = () => {
    const positionBackgroundFrame = landmark.iteration * (panoramicWidth * 12);
    const positionLandmarkDegree= (panoramicWidth * 12) * landmark.degrees / 360;
    const left =  positionBackgroundFrame + positionLandmarkDegree;
    landmarkRef.current.style.left = `${left}px`
  }

  React.useEffect( () => {
    if(isAnimatingIn){
      toggleActiveStateOfLandmark(index);
      animateInLandmark();
    }
  },[isAnimatingIn])

  const openLandmarkDetails = () => {
    if(!isAnimatingIn && !landmark.active && !isAnimatingOut){
      setIsAnimatingIn(true);
    }
  }

  const animateInLandmark = () => {
    let viewportLeftValue = orientation - landmark.degrees
    viewportLeftValue = Math.abs(viewportLeftValue - 15 );
    viewportLeftValue = viewportLeftValue / 30 * 100;
    landmarkRef.current.style.left = `${viewportLeftValue}%`;
    landmarkRef.current.style.width = `80vw`;
    landmarkRef.current.style.zIndex = `2`;
    informationRef.current.style.width = `auto`;
    
    setTimeout( () => {
      landmarkRef.current.style.transition="0.9s"
      landmarkRef.current.style.left=`${panoramicWidth/2}px`
      landmarkRef.current.style.top=`calc(100% 
        - ${ICON_IMAGE_SELECTED_HEIGHT_PX}px 
        - ${INFORMATION_BOX_HEIGHT_ON_SELECTED_PX}px
        - ${LANDMARK_MARGIN_BOTTOM_VH}vh 
        + ${INFORMATION_BOX_OVERLAPPED_ON_ICON_PX}px)`;
    },100)
    setTimeout( () => {
      setIsAnimatingIn(false);
    },1000)
  }

  React.useEffect( () => {
    if(isAnimatingOut){
      toggleActiveStateOfLandmark(index);
      animateOutLandmark();
    }
  },[isAnimatingOut])

  const closeLandmarkDetails = () => {
    if(!isAnimatingOut && landmark.active){
      setIsAnimatingOut(true);
    }
  }

  const animateOutLandmark = () => {
    let landmarkPosition = moveLandmark(orientation);
    landmarkRef.current.style.transition="none";
    landmarkRef.current.style.left = `${landmarkPosition}px`;
    landmarkRef.current.style.top=`calc(100% 
      - ${ICON_IMAGE_SELECTED_HEIGHT_PX}px 
      - ${INFORMATION_BOX_HEIGHT_ON_SELECTED_PX}px
      - ${LANDMARK_MARGIN_BOTTOM_VH}vh 
      + ${INFORMATION_BOX_OVERLAPPED_ON_ICON_PX}px)`;
    
    setTimeout( () => {
      landmarkRef.current.style.transition="0.9s";
      landmarkRef.current.style.top=`calc(100% 
        - ${ICON_IMAGE_SELECTED_HEIGHT_PX}px 
        - ${INFORMATION_BOX_HEIGHT_ON_SELECTED_PX}px
        - ${LANDMARK_MARGIN_BOTTOM_VH}vh 
        + ${INFORMATION_BOX_OVERLAPPED_ON_ICON_PX}px
        + ${ICON_HEIGHT_DIFFERENCE_PX}px)`;
      placeLandmarkInBackground();
    },100)
    setTimeout(function () {
      informationRef.current.style.width = `0px`;
      landmarkRef.current.style.width = `auto`;
      landmarkRef.current.style.transition = `none`;
      landmarkRef.current.style.zIndex = `1`;
      setIsAnimatingOut(false);
    }, 1000)
    setArrowClass("inactive");
  }
  
  const moveLandmark = (compass) => {
    const positionBackgroundFrame = (currentFrame - 1) * (panoramicWidth * 12);
    const positionBackgroundDegrees= (panoramicWidth * 12) * compass / 360
    const left =  positionBackgroundFrame + positionBackgroundDegrees;
    return left;
  }

  return (
    <div 
      ref={landmarkRef} 
      className={`landmark informational-popup ${landmark.active ? "active" : "inactive"}`}
    >
      <div className="image" 
        style={{height: landmark.active ? `${ICON_IMAGE_SELECTED_HEIGHT_PX}px` : `${ICON_IMAGE_HEIGHT_PX}px`}}>
        <div className="image-container">
          <img 
            alt="" 
            src={require(`./../../assets/images/trailmap/${landmark.src}`)}
            onClick={openLandmarkDetails}
          />
          <ArrowShadow className={`arrow ${arrowClass}`}/>
        </div>
        <button onClick={closeLandmarkDetails}>
          <CloseIcon/>
        </button>
      </div>
      <div className="information"ref={informationRef}>
        <div className="overflowed">
            <h4>{landmark.name}</h4>
            <p>{landmark.description}
            </p>
        </div>
      </div>
    </div>
  )
}

export default Landmark;
